import { apiRequest, API_URL, getAuthToken } from "./api";

export const contentService = {
  getContent: async () => apiRequest("/settings/content", { method: "GET" }),

  updateSection: async (section, fields) =>
    apiRequest(`/settings/content/${section}`, {
      method: "PUT",
      requiresAuth: true,
      body: JSON.stringify(fields),
    }),

  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append("image", file);
    const res = await fetch(`${API_URL}/settings/content/upload-image`, {
      method: "POST",
      headers: { Authorization: `Bearer ${getAuthToken() || ""}` },
      body: formData,
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.message || "Failed to upload image");
    }
    return res.json();
  },
};
